import { jsx as _jsx } from "react/jsx-runtime";
export const SvgMenu2 = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'M4.5 6h15m-15 6h15m-15 6h15' }) }));
//# sourceMappingURL=menu-2.js.map